import React from "react";
import { Route, Switch } from "react-router-dom";
import BoreholeUpload from './BoreholeUpload';
import AddBorehole from './AddBorehole';
import EditBorehole from './EditBorehole';
import BoreholeList from './BoreholeList';
import BoreholeLogViewerV2 from './BoreholeLogViewerV2';
import ImageViewer from '../../components/image-viewer/image-viewer';
import MapViewer from '../../components/map-viewer/container';
import MapViewer10000 from '../../components/map-viewer/container10000';
import { PrivateRoute } from "../../components/privateRoute";

const BoreholeRoutes = ({setBorehole}: any) => {
  return (
    
    <Switch>
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole">
        <BoreholeList setBorehole={setBorehole}/>
      </PrivateRoute>          
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/tracks">
        <BoreholeLogViewerV2 setBorehole={setBorehole} />
      </PrivateRoute>          
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/log-viewer">
        <BoreholeLogViewerV2 setBorehole={setBorehole} />
      </PrivateRoute>          
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/log-viewer/:templateId">
        <BoreholeLogViewerV2 setBorehole={setBorehole} />
      </PrivateRoute>
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/log-viewer/view/:viewId">
        <BoreholeLogViewerV2 setBorehole={setBorehole} />
      </PrivateRoute>
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/add">
        <AddBorehole setBorehole={setBorehole}/>
      </PrivateRoute>          
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/files">
        <BoreholeUpload setBorehole={setBorehole}/>
      </PrivateRoute>
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/edit">
        <EditBorehole setBorehole={setBorehole}/>
      </PrivateRoute>      
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/image-viewer">
        <ImageViewer setBorehole={setBorehole}/>
      </PrivateRoute>
      <PrivateRoute exact path="/client/:clientId/project/:projectId/borehole/:boreholeId/image-viewer/:templateId">
        <ImageViewer setBorehole={setBorehole}/>
      </PrivateRoute>
      <PrivateRoute exact path="/client/:clientId/project/:projectId/map-viewer">
        <MapViewer setBorehole={setBorehole}/>
      </PrivateRoute>
      <PrivateRoute exact path="/client/:clientId/project/:projectId/map-viewer10000">
        <MapViewer10000 />
      </PrivateRoute>
      {/* <PrivateRoute exact path="/client/:clientId">
        <BoreholeList setBorehole={setBorehole}/>
      </PrivateRoute> */}
      <PrivateRoute exact path="/">
        <BoreholeList setBorehole={setBorehole}/>
      </PrivateRoute>
    </Switch>                   
    
  );
};

export default BoreholeRoutes;
